var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEditIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#5D5CF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08554 14.4883L9.51172 16.9141L16.2181 10.2089L13.7919 7.78313L7.08554 14.4883Z",
    fill: "#5D5CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7765 7.51039L16.4876 6.22173C16.1735 5.90772 15.6422 5.9299 15.3007 6.27128L14.0898 7.48197L16.516 9.9077L17.7269 8.69703C18.0683 8.35565 18.0905 7.82437 17.7765 7.51039Z",
    fill: "#5D5CF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85777 14.875L6.18581 17.3246C6.10379 17.6235 6.37837 17.8981 6.67735 17.8161L9.12714 17.1443L6.85777 14.875Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/editIcon.40dd71c4.svg";
export { ForwardRef as ReactComponent };